export default __webpack_public_path__ + "static/media/video-bg.66e910be.mp4";